import { render } from "./OutgoingParcel.vue?vue&type=template&id=25af153c&scoped=true"
import script from "./OutgoingParcel.vue?vue&type=script&lang=js"
export * from "./OutgoingParcel.vue?vue&type=script&lang=js"

import "./OutgoingParcel.vue?vue&type=style&index=0&id=25af153c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25af153c"]])

export default __exports__